import { storage } from "lib";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Flex, Modal, Tabs } from "antd";
import alert from "components/elements/Alert";

import ModalCreatePosition from "components/elements/Modal/ModalCreatePosition";
import ModalLevel from "components/elements/Modal/ModalLevel";
import ModalOrganization from "components/elements/Modal/ModalOrganization";
import CompanyOrganizationEdit from "../components/CompanyOrganizationEdit";
import CompanyPositionEdit from "../components/CompanyPositionEdit";
import CompanyBranchListEdit from "../pages/CompanyBranchListEdit";
import CompanyBranchMain from "../pages/CompanyBranchListMain";
import CompanyBranchView from "../pages/CompanyBranchListView";
import CompanyDocumentEdit from "../pages/CompanyDocumentEdit";
import CompanyDocumentView from "../pages/CompanyDocumentView";
import CompanyOrganizationView from "../pages/CompanyOrganizationView";
import CompanyOvertimeEdit from "../pages/CompanyOvertimeEdit";
import CompanyOvertimeView from "../pages/CompanyOvertimeView";
import CompanyPositionView from "../pages/CompanyPositionView";
import CompanyProfileEdit from "../pages/CompanyProfileEdit";
import CompanyProfileView from "../pages/CompanyProfileView";
import CompanyWorkingEdit from "../pages/CompanyWorkingEdit";
import CompanyWorkingView from "../pages/CompanyWorkingView";

import useOptions from "features/masterData/hooks/useOptions";
import { PERMISSIONS_CONFIG } from "../data/companyProfile";
import usePosition from "../hooks/usePosition";
import CompanyAppearance from "../pages/CompanyAppearance";
import { COMPANY_PAGE, COMPANY_PAGE_LIST } from "../schemas/companySchema";
import { setIsLoading } from "../slices/companySlice";
import useOrganization from "./useOrganization";

const PAGE_TYPE = {
  view: "view",
  edit: "edit",
  delete: "delete",
  main: "main",
  create: "create",
};

function useCompanyProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCompany, setCompany] = useState(1);
  const [selectedMenu, setMenu] = useState();
  const [pageType, setPageType] = useState(PAGE_TYPE.view);
  const [levelModal, setLevelModal] = useState(false);
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState("en");
  const [level, setLevel] = useState(0);
  const [node, setNode] = useState([]);
  const [isCompany, setIsCompany] = useState(false);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const positionList = useSelector((state) => state.company.positionList);
  const departmentList = useSelector((state) => state.company.departmentList);
  const companyInformation = useSelector(
    (state) => state.company.companyInformation
  );
  const roles = useSelector((state) => state.company.roles);
  // console.log("🚀 ~ useCompanyProfile ~ roles:", roles)
  const [permissions, setPermissions] = useState({})

  const getPermissions = (menu) => {
    const permissions = PERMISSIONS_CONFIG[menu] || {};
    return Object.keys(permissions).reduce((acc, perm) => {
      acc[perm] = roles.includes(permissions[perm]);
      return acc;
    }, {});
  };
  useEffect(() => {
    const newPermissions = getPermissions(selectedMenu);
    setPermissions(newPermissions);
  }, [selectedMenu, roles]);

  console.log("newPermissions", permissions);


  const canEdit = roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION");
  const canCreate = roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|ORGANIZATION");

  const positionCreate = roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|POSITION");
  const positionEdit = roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|POSITION");

  const onEdit = useCallback(() => {
    setPageType(PAGE_TYPE.edit);
  }, [setPageType]);

  const {
    createPosition,
    setcreateModal,
    editModal,
    seteditModal,
    createModal,
    deletePosition,
    updatePosition,
    modifiedPositionOptions,
  } = usePosition(onEdit);

  const {
    deleteDepartment,
    updateDepartment,
    setCreateOrgnizationModal,
    setEditOrgnizationModal,
    createDepartment,
    createOrgnizationModal,
    editOrgnizationModal,
    organizationLevelOption,
    organizationUnderOptions,
  } = useOrganization(onEdit);

  const {
    socialSecurityBranchOptions = [],
    acountTypeOption = [],
    getSocialSecurityBranchOption,
    getSetAcountTypeOption,
  } = useOptions();
  const onView = useCallback(() => {
    setPageType(PAGE_TYPE.view);
  }, [setPageType]);

  const onCreate = useCallback(() => {
    navigate("/configuration/company/create");
  }, [navigate]);

  const handleChange = useCallback(
    (value) => {
      setCompany(value);
    },
    [setCompany]
  );
  const onSubmit = (value, cb = () => { }) => {
    const values = {
      ...value,
      level: level,
    };

    createPosition(values, cb);
  };

  const onSubmitEdit = (value) => {
    const values = {
      ...value,
      level: level,
    };

    updatePosition(values);
  };

  const handleOpenCreateOrganizationModal = (value, node, IsCompany) => {
    setNode(node);
    setIsCompany(IsCompany);
    setCreateOrgnizationModal(value);
  };

  const handleOpenEditOrganizationModal = (value, node, IsCompany) => {
    console.log("nodenode", node);
    setNode(node);
    setIsCompany(IsCompany);
    setEditOrgnizationModal(value);
  };
  const onSubmitCreateDepartment = (value, cb = () => { }) => {
    const values = {
      ...value,
      node,
    };
    createDepartment(values, cb);
  };
  const onSubmitEditDepartment = (value) => {
    const values = {
      ...value,
      node,
    };

    updateDepartment(values);
  };
  const handleOpenLevelModal = (value) => {
    setLevelModal(value);
  };
  const handleOpenCreateModal = (value, node) => {
    console.log("companyProfile 162 Create ", node);
    setNode(node);
    setLevel(node.level);
    setcreateModal(value);
  };
  // * remark
  const handleOpenEditModal = (value, node) => {
    console.log("companyProfile 162 Edit ", node);
    setNode(node);
    setLevel(node.level);
    seteditModal(value);
  };
  const onCreateBranch = useCallback(() => {
    setPageType(PAGE_TYPE.create);
  }, [setPageType]);

  const onMain = useCallback(() => {
    setPageType(PAGE_TYPE.main);
  }, [setPageType]);

  const handleMenuChange = useCallback(
    (e) => {
      seteditModal(false);
      setcreateModal(false);
      setLevelModal(false);
      if (e === "branch_list") {
        setPageType(PAGE_TYPE.main);
      } else {
        setPageType(PAGE_TYPE.view);
      }

      if (MENU === "branch_list" && e !== "branch_list") {
        setPageType(PAGE_TYPE.view);
      }

      setMenu(e);
    },
    [setcreateModal, seteditModal]
  );

  const onSave = useCallback(() => {
    Modal.confirm({
      title: "Confirmation",
      content: (
        <>
          <p>Are you sure confirm to edit company profile ?</p>
        </>
      ),
      onOk() {
        setPageType(PAGE_TYPE.view);
        seteditModal(false);
        setLevelModal(false);
        setcreateModal(false);
        alert({ message: "Success" });
      },
      okText: "CONFIRM",
      cancelText: "CANCEL",
    });
  }, [setcreateModal, seteditModal]);

  const onCancel = useCallback(() => {
    seteditModal(false);
    setLevelModal(false);
    setcreateModal(false);
    setCreateOrgnizationModal(false);
    setEditOrgnizationModal(false);
  }, [
    setCreateOrgnizationModal,
    setEditOrgnizationModal,
    setcreateModal,
    seteditModal,
  ]);

  const onCancelEdit = useCallback(() => {
    setPageType(PAGE_TYPE.view);
  }, [setPageType]);

  const onDelete = useCallback(() => {
    Modal.confirm({
      title: "Confirmation",
      content: (
        <>
          <p>Are you sure confirm to delete company profile ?</p>
        </>
      ),
      onOk() {
        setPageType(PAGE_TYPE.main);
        alert({ message: "Success" });
      },
      okText: "CONFIRM",
      cancelText: "CANCEL",
    });
  }, [setPageType]);

  const onDeletePosition = (value) => {
    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (
        i18n.language === "en"
          ? "Are you sure confirm to delete position ?"
          : "คุณแน่ใจหรือไม่ที่จะยืนยันการลบตำแหน่ง ?"
      ),
      onOk() {
        deletePosition(value);
      },
      okText: t("common.confirm").toUpperCase(),
      cancelText: t("common.cancel").toUpperCase(),
    });
  };

  const onDeleteDepartment = (value) => {
    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (
        i18n.language === "en"
          ? "Are you sure confirm to delete department ?"
          : "คุณแน่ใจหรือไม่ที่จะยืนยันการลบแผนก ?"
      ),
      onOk() {
        deleteDepartment(value);
      },
      okText: t("common.confirm").toUpperCase(),
      cancelText: t("common.cancel").toUpperCase(),
    });
  };

  // getItem("working_condition", "Working Condition", "condition.working"),
  // getItem("overtime_condition", "Overtime Condition", "condition.overtime"),
  const MENU = [
    {
      label: t('working_condition.header'),
      key: "condition",
    },
    {
      label: t('overtime_condition.header'),
      key: "condition.overtime",
    },
  ];

  const handleCancel = useCallback(() => {
    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content:
        i18n.language === "en"
          ? "Are you sure you want to cancel the changes?"
          : "คุณต้องการยกเลิกการแก้ไขใช่หรือไม่ ?",
      onOk() {
        // onCancel();
        onCancelEdit();
      },
      okText: t("common.confirm"),
      cancelText: t("common.cancel"),
    });
  }, [onCancel, t, i18n.language]);

  const getPage = useCallback(() => {
    console.log("selectedMenu", selectedMenu);

    switch (selectedMenu) {
      case "profile":
        return pageType === PAGE_TYPE.view ? (
          <CompanyProfileView onEdit={onEdit} />
        ) : (
          <CompanyProfileEdit onCancel={handleCancel} onClear={onCancelEdit} />
        );
      case "condition":
        return pageType === PAGE_TYPE.view ? (
          <Flex gap={20} vertical={true}><Tabs items={MENU} onChange={handleMenuChange} /><CompanyWorkingView onEdit={onEdit} /></Flex>
        ) : (
          <Flex gap={20} vertical={true}><Tabs items={MENU} onChange={handleMenuChange} /><CompanyWorkingEdit onCancel={onCancelEdit} /></Flex>
        );
      case "condition.overtime":
        return pageType === PAGE_TYPE.view ? (
          <Flex gap={20} vertical={true}><Tabs items={MENU} onChange={handleMenuChange} /><CompanyOvertimeView onEdit={onEdit} /></Flex>
        ) : (
          <Flex gap={20} vertical={true}><Tabs items={MENU} onChange={handleMenuChange} /><CompanyOvertimeEdit onCancel={onCancelEdit} /></Flex>
        );
      case "branch_list":
        return pageType === PAGE_TYPE.main ? (
          <CompanyBranchMain
            onView={onView}
            onEdit={onEdit}
            onCreate={onCreateBranch}
            onDelete={onDelete}
          />
        ) : pageType === PAGE_TYPE.view ? (
          <CompanyBranchView onCancel={onMain} onEdit={onEdit} />
        ) : pageType === PAGE_TYPE.create ? (
          <CompanyBranchListEdit createMode onCancel={onMain} />
        ) : (
          <CompanyBranchListEdit onCancel={onMain} />
        );
      case "document":
        return pageType === PAGE_TYPE.view ? (
          <CompanyDocumentView onEdit={onEdit} />
        ) : (
          <CompanyDocumentEdit onCancel={onCancelEdit} />
        );

      case "position":
        return pageType === PAGE_TYPE.edit ? (
          <CompanyPositionEdit
            positionList={positionList}
            onCancel={onCancelEdit}
            onSave={onSave}
            getModal={getModal}
            getEditModal={getEditModal}
            handleOpenCreateModal={handleOpenCreateModal}
            handleOpenEditModal={handleOpenEditModal}
            deletePosition={onDeletePosition}
            lang={lang}
          />
        ) : (
          <CompanyPositionView onEdit={onEdit} />
        );
      case "organization":
        return pageType === PAGE_TYPE.edit ? (
          <CompanyOrganizationEdit
            onCancel={onCancelEdit}
            companyInformation={companyInformation}
            departmentList={departmentList}
            organizationMaxLevel={organizationLevelOption.length}
            onSave={onSave}
            getModal={getModal}
            getEditModal={getEditModal}
            handleOpenCreateModal={handleOpenCreateOrganizationModal}
            handleOpenEditModal={handleOpenEditOrganizationModal}
            onDeleteDepartment={onDeleteDepartment}
            lang={lang}
          />
        ) : (
          <CompanyOrganizationView
            onEdit={onEdit}
            getOrganization={getOrganization}
            handleOpenLevelModal={handleOpenLevelModal}
          />
        );
      case "appearance":
        return permissions?.ACCESS && (<CompanyAppearance permissions={permissions} />)
      default:
        return <div />;
    }
  }, [
    selectedMenu,
    pageType,
    onEdit,
    onCancel,
    onView,
    onCreateBranch,
    onDelete,
    onMain,
    setcreateModal,
    onDeletePosition,
    onSubmit,
    onSubmitEdit,
    createOrgnizationModal,
    editOrgnizationModal,
    createModal,
    editModal,
    levelModal,
    node,
    positionList,
  ]);

  const getModal = useCallback(() => {
    switch (selectedMenu) {
      case "position":
        return (
          <ModalCreatePosition
            node={node}
            title={t("common.create")}
            isModalOpen={createModal}
            submit="CREATE"
            onSubmit={onSubmit}
            handleCancel={onCancel}
            modifiedPositionOptions={modifiedPositionOptions}
            blankForm
          />
        );
      case "organization":
        return (
          <ModalOrganization
            node={node}
            isCompany={isCompany}
            onSubmit={onSubmitCreateDepartment}
            title={t("common.create")}
            isModalOpen={createOrgnizationModal}
            submit="CREATE"
            handleOk={onCancel}
            handleCancel={onCancel}
            socialSecurityBranchOptions={socialSecurityBranchOptions}
            acountTypeOption={acountTypeOption}
            organizationLevelOption={organizationLevelOption}
            organizationUnderOptions={organizationUnderOptions}
            lang={lang}
            blankForm
          />
        );
      default:
        return <div />;
    }
  }, [
    createModal,
    selectedMenu,
    node,
    onCancel,
    onSubmit,
    onSubmitCreateDepartment,
    modifiedPositionOptions,
    createOrgnizationModal,
    acountTypeOption,
  ]);

  const getOrganization = useCallback(() => {
    return (
      <ModalLevel
        modifiedOrganizationLevelOptions={organizationLevelOption}
        title="Organization Level"
        isModalOpen={levelModal}
        handleOk={onCancel}
        handleCancel={onCancel}
      />
    );
  }, [levelModal, onCancel, organizationLevelOption]);

  const getEditModal = () => {
    switch (selectedMenu) {
      case "position":
        return (
          <ModalCreatePosition
            title={positionCreate && !positionEdit ? t("common.info_detail") : t("common.edit")}
            isModalOpen={editModal}
            handleOk={onCancel}
            handleCancel={onCancel}
            onSubmit={onSubmitEdit}
            node={node}
            modifiedPositionOptions={modifiedPositionOptions}
          />
        );
      case "organization":
        return (
          <ModalOrganization
            node={node}
            isCompany={isCompany}
            onSubmit={onSubmitEditDepartment}
            title={canCreate && !canEdit ? t("common.info_detail") : t("common.edit")}
            isModalOpen={editOrgnizationModal}
            organizationLevelOption={organizationLevelOption}
            handleOk={onCancel}
            handleCancel={onCancel}
            socialSecurityBranchOptions={socialSecurityBranchOptions}
            acountTypeOption={acountTypeOption}
            organizationUnderOptions={organizationUnderOptions}
            lang={lang}
          />
        );
      default:
        return <div />;
    }
  };

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language, setLang]);

  useEffect(() => {
    if (currentCompany != null) {
      getSocialSecurityBranchOption();
    }
  }, [dispatch, currentCompany, getSocialSecurityBranchOption]);

  useEffect(() => {
    if (currentCompany != null) {
      getSetAcountTypeOption();
    }
  }, [dispatch, currentCompany, getSetAcountTypeOption]);

  return {
    setIsLoading,
    pageType,
    setPageType,
    selectedCompany,
    selectedMenu,
    onView,
    onEdit,
    onCreate,
    handleChange,
    handleMenuChange,
    onSave,
    onCancel,
    getPage,
    setMenu
  };
}

export default useCompanyProfile;
